import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import download from '../images/download-doc.svg';
// import downloadpdf from '../images/download-pdf.png';
import "react-daterange-picker/dist/css/react-calendar.css";
import spinner from '../../assign-prescriptions/images/spinner.gif';
import { IconButton, Grid, Box } from "@mui/material";
import '../../assign-prescriptions/index.css';
import moment from 'moment-timezone';
import { withTranslation } from "react-i18next";
import getPatientTypeNameByType from '../../common/getPatientTypeNameByType';
import ReportsAGGrid from "../reportsGrid/reportsAGGrid";
import CloseIcon from '@mui/icons-material/Close';

const styles = theme => ({
  root: {
    width: "100%",
    // marginTop: theme.spacing.unit * 3
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none'
  },
});

const TransactionSortObj = {
  first_name: { tableName: '', sortColumn: 'first_name' },
  last_name: { tableName: '', sortColumn: 'last_name' },
  drivers_license_no: { tableName: '', sortColumn: 'drivers_license_no' },
  dob_str: { tableName: '', sortColumn: 'dob_str' },
  email: { tableName: 'contacts', sortColumn: 'email' },
  phone: { tableName: 'contacts', sortColumn: 'phone' },
  member_id: { tableName: '', sortColumn: 'member_id' },
  enroll_date: { tableName: '', sortColumn: 'created_on' },
  name: { tableName: 'customer_type', sortColumn: 'name' },
}

let TransactionFilterObj = {
  searchObject: null,
  fromdate: '',
  todate: '',
  pageNo: 0,
  pageSize: 25,
  sortOrder: 'desc',
  sortColumn: 'created_on',
  tableName: ''
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      rowsPerPage: 25,
      loader: false,
      isButtonDisabled: false,
      data: []
    };
  }

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem('i18nextLng');
    let zone;
    zone = sessionStorage.getItem('timeZone');
    const date = moment(new Date(requestDate));
    if (['null', null, 'undefined', undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
  }

  exportCSV() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'CSV/EnrolledPatientReport', {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(TransactionFilterObj)
    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      }).then((csvData) => {
        const currentUserLang = localStorage.getItem('i18nextLng');
        this.setState({ loader: false });
        let csvRow = [];
        let Array = [['ID', 'FirstName', 'LastName', 'Drivers License No', 'DOB', 'Email', 'Phone', 'Source', 'Enroll Date/Time']];
        let result = csvData && csvData.Results && csvData.Results.length > 0 ? csvData.Results : [];
        if (result !== undefined && result !== 'undefined') {
          if (result && result.length > 0) {
            for (let i of result) {
              if (i.dob_str) {
                i.dob_str = currentUserLang === 'en' ? moment(i.dob_str).format('MM/DD/YYYY') : moment(i.dob_str).format('DD/MM/YYYY')
              } else {
                i.dob_str = '';
              }
              Array.push(
                [
                  i.first_name,
                  i.last_name,
                  i.member_id,
                  i.drivers_license_no,
                  i.dob_str,
                  i.email,
                  i.phone,
                  i.name,
                  i.enroll_date ? this.convertToTimeZone(i && i.enroll_date) : ''
                ]
              );
            }

            for (let i of Array) {
              csvRow.push(i.join(","));
            }
            let csvString = csvRow.join("%0A");
            let element = document.createElement("a");
            element.href = 'data:attachment/csv.' + csvString;
            element.target = "_Blank";
            element.download = "EnrolledPatientsReport.csv";
            document.body.appendChild(element);
            element.click();
          }
        }
      });
  };

  NameCellFormatter = (t) => {
    return (params) => {
      const patientType = getPatientTypeNameByType(params.value, t)
      return patientType ? patientType : ''
    }
  }

  DateCellFormatter = (params) => {
    return this.convertToTimeZone(params.value)
  }

  onGridReady = (params) => {
    this.gridApi = params.api
    const datasource = this.getServerSideDatasource()
    // register datasource with the grid
    this.gridApi.setServerSideDatasource(datasource);
  }

  clearFilters = () => {
    const filterModel = this.gridApi.getFilterModel();
    if (Object.keys(filterModel).length > 0) {
      this.gridApi.setFilterModel(null);
      TransactionFilterObj.searchObject = null;
      TransactionFilterObj.fromdate = '';
      TransactionFilterObj.todate = '';
      this.gridApi.refreshServerSide();
    }
  };

  getServerSideDatasource = () => {
    const self = this;
    return {
      getRows(params) {
        TransactionFilterObj.pageNo = Math.floor(params.request.startRow / self.state.rowsPerPage)

        const filterObject = params.request && params.request.filterModel
        const filterColumns = Object.keys(filterObject)

        // to set fromdate and todate for assigned date
        if (filterObject.enroll_date) {
          const dateValue = filterObject.enroll_date;
          if (dateValue.operator) {
            // for date range
            if (dateValue.condition1.type === 'fromdate' && dateValue.condition2.type === 'todate') {
              const date1 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
              const date2 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
              TransactionFilterObj.fromdate = date1
              TransactionFilterObj.todate = date2
            }
            if (dateValue.condition2.type === 'fromdate' && dateValue.condition1.type === 'todate') {
              const date2 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
              const date1 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
              TransactionFilterObj.fromdate = date1
              TransactionFilterObj.todate = date2
            }
          } else {
            // for from/to date
            const date = moment(dateValue.dateFrom).format('YYYY-MM-DD')
            if (dateValue.type === 'fromdate') {
              TransactionFilterObj.fromdate = date
              TransactionFilterObj.todate = ''
            } else {
              TransactionFilterObj.todate = date
              TransactionFilterObj.fromdate = ''
            }
          }
        } else {
          TransactionFilterObj.todate = '';
          TransactionFilterObj.fromdate = ''
        }

        if (filterObject) {
          if (filterColumns.length === 0) {
            TransactionFilterObj.searchObject = null
          } else {
            TransactionFilterObj.searchObject = filterObject
          }
        }

        if (params.request.sortModel.length > 0) {
          TransactionFilterObj.tableName = TransactionSortObj[params.request.sortModel[0].colId].tableName
          TransactionFilterObj.sortColumn = TransactionSortObj[params.request.sortModel[0].colId].sortColumn
          TransactionFilterObj.sortOrder = params.request.sortModel[0].sort
        }

        apiCall()

        function apiCall() {
          self.setState({ loader: true });
          fetch(process.env.REACT_APP_BASEURL + 'getkioskcustomer', {
            method: 'post',
            withCredentials: true,
            headers: {
              Authorization:
                'Bearer ' +
                JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                  .jwtToken,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(TransactionFilterObj),
          })
            .then((httpResponse) => {
              try {
                return httpResponse.json();
              } catch (error) {
                return null;
              }
            })
            .then((response) => {
              if (response && response.results) {
                if (response.results.length > 0) {
                  params.successCallback(response.results, response.total);
                  self.setState({ data: response.results, isButtonDisabled: false })
                } else {
                  params.successCallback([], 0);
                  self.setState({ data: [], isButtonDisabled: true })
                }
                self.setState({ loader: false })
              }
            })
            .catch(error => {
              self.setState({ loader: false })
              console.error(error);
              params.failCallback();
            });
        }
      }
    };
  }

  render() {
    const { classes, t } = this.props;
    const { data } = this.state;

    const columnDefs = [
      { field: "first_name", headerName: t("Report.Patient.FirstName"), },
      { field: "last_name", headerName: t("Report.Patient.LastName") },
      { field: "member_id", headerName: t("Report.Patient.MemberID") },
      { field: "drivers_license_no", headerName: t("Report.Patient.DriverLicenceNo") },
      { field: "dob_str", headerName: t("Report.Patient.DOB") },
      { field: "email", headerName: t("Report.Patient.Email") },
      { field: "phone", headerName: t("Report.Patient.Phone") },
      { field: "name", headerName: t("Report.Patient.Source"), cellRenderer: this.NameCellFormatter(t) },
      {
        field: "enroll_date", headerName: t("Report.Patient.EnrollDateTime"),
        cellRenderer: this.DateCellFormatter,
        filter: 'agDateColumnFilter',
        filterParams: {
          filterOptions: [
            {
              displayKey: 'fromdate',
              displayName: t('Report.Patient.FromDate'),
              predicate: (_, cellValue) => cellValue
            },
            {
              displayKey: 'todate',
              displayName: t('Report.Patient.ToDate'),
              predicate: (_, cellValue) => cellValue
            },
          ],
          maxNumConditions: 2,
        },
      }
    ];

    return (
      <Paper className={classes.root}>
        {
          this.state.loader ?
            <div className={classes.spinner}>
              <img className={classes.spinnerImage} src={spinner} alt="loading" />
            </div> :
            null
        }
        <Box component="div">
          <Grid container direction={'row'} alignItems={'center'} justifyContent={'flex-end'} spacing={0} sx={{ ml: 0, mr: 1, width: '100%', border: 'solid 1px #babfc7', borderBottom: 'none' }}>
            <Grid item xs={3} md={3} sx={{ textAlign: 'end' }}>
              <Tooltip key="clear-filters" title={t("Report.Patient.ClearFiltersTooltip")}>
                <IconButton onClick={() => this.clearFilters()} style={{ backgroundColor: "#00a7e1" }}>
                  <CloseIcon style={{ color: "white" }} />
                </IconButton>
              </Tooltip>
              <Tooltip key="export-csv" title={t("Report.Patient.ExportCSVTooltip")}>
                <IconButton
                  style={{ marginRight: '0' }}
                  aria-label="ExportCSV"
                  disabled={this.state.isButtonDisabled}
                >
                  <img alt="download" onClick={() => { this.exportCSV() }} src={download} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                </IconButton>
              </Tooltip>
              {/* <Tooltip key="export-pdf" title={t("Report.Patient.ExportPDFTooltip")}>
                <IconButton
                  aria-label="ExportPDF"
                  onClick={() => { this.exportPDF() }}
                  disabled={this.state.isButtonDisabled}
                >
                  <img alt="download" src={downloadpdf} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                </IconButton>
              </Tooltip> */}
            </Grid>
          </Grid>
        </Box>
        <ReportsAGGrid
          columnDefs={columnDefs}
          sideBar={false}
          suppressMenuHide={true}
          rowData={data}
          defaultColDef={{
            flex: 1,
            minWidth: 150,
            floatingFilter: true,
            filter: 'agTextColumnFilter',
            filterParams: {
              filterOptions: [{
                displayKey: 'searchtext',
                displayName: 'Search Text',
                predicate: (cellValue) => cellValue
              }],
              maxNumConditions: 1,
            },
            resizable: true,
            sortable: true,
            menuTabs: ['generalMenuTab', 'columnsMenuTab'],
          }}
          onGridReady={this.onGridReady}
        />
      </Paper>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/reports/enrolled-patients/index.js